import {

    SET_STARASSIGNMENT_LIST,
    SET_STARASSIGNMENT_TYPE_CATEGORY,
    SET_STARTYPES_LIST,
    SET_CARDSLIST,
    SET_LIST_HISTORICAL_TEMPLATE,
    SET_DOWNLOAD_TEMPLATE,
    SET_POST_TEMPLATE,
    SET_LIST_TYPE_STAR_LIST,
    SET_ZEN_STAR_REQUESTS,
    SET_STAR_ZEN_STATUS,
    SET_JOB_STATUS,
} from "@/views/star_assignment/store/types/types.js";

const mutations = {

    [SET_STARASSIGNMENT_LIST ]: (state, payload) => state.typeDocumentStarassignment = payload,
    [SET_STARTYPES_LIST ]: (state, payload) => state.typeStar = payload,
    [SET_STARASSIGNMENT_TYPE_CATEGORY]: (state, payload) => state.typeCategoryStarAssignment = payload,
    [SET_CARDSLIST]: (state, payload) => state.cardsList = payload,
    [SET_LIST_HISTORICAL_TEMPLATE]: (state, payload) => state.template = payload,
    [SET_DOWNLOAD_TEMPLATE]: (state, payload) => state.templateDownload = payload,
    [SET_POST_TEMPLATE]: (state, payload) => state.postTemplate = payload,
    [SET_LIST_TYPE_STAR_LIST] :  (state, payload) => state.listTypeStar = payload,
    [SET_ZEN_STAR_REQUESTS] :  (state, payload) => state.listZenStarRequests = payload,
    [SET_STAR_ZEN_STATUS]:  (state, payload) => state.listStarZenStatus = payload,
    [SET_JOB_STATUS]: (state, payload) => state.jobStatus = payload,
};

export default mutations